import GenericButton from '@ui-components/Button/GenericButton';
import { ReactComponent as LeftIcon } from "../../../../../assets/Icons/IconLeft.svg";
import React from 'react'
import { useNavigate } from "react-router-dom";

export default function OutagesTabs() {
    const navigate = useNavigate();
  return (
    <div
        className="
            flex
            justify-end
            w-full
            mt-1
        "
        > 
        <GenericButton
            variant="secondary"
            shape="ghost"
            size="sm"
            icon={<LeftIcon className="h-5 w-5 text-semantic-text-secondary" />}
            onClick={() => { navigate("/kontrol")}}
        />
    </div>

  )
}
